import { useEntityMetadata } from '@msdk/common'
import { LookupValue } from '@msdk/definitions'
import { useFormModal } from '@msdk/forms'
import { styled, Typography } from '@msdk/ui'
import React from 'react'

interface Props {
  value?: LookupValue
}

const StyledTypography = styled(Typography)`
  color: #0366d6;
  cursor: pointer;
  text-decoration: underline;
`

export function LookupFieldRenderer({ value }: Props) {
  const modal = useFormModal()
  const model = useEntityMetadata(value?.entityName)

  const handleClick = () => {
    if (value) {
      const form = model?.defaultForm as string
      const modalRef = modal.createModal(value.entityName, form, value.value as string, () => {
        //do nothing
      })
      modalRef.open()
    }
  }

  return (
    <StyledTypography variant="body1" onClick={handleClick}>
      {value ? value.toStringForView() : '-'}
    </StyledTypography>
  )
}
